<template>
    <div class="min-h-screen bg-[#f2f2f7]">

        <!-- CHARGEMENT -->
        <div v-if="loading" class="flex flex-col items-center gap-3 h-screen justify-center">
            <div class="w-8 h-8 border-2 border-gray-200 border-t-orange-500 rounded-full animate-spin"></div>
            <p class="text-sm text-gray-400 font-medium">Chargement…</p>
        </div>

        <!-- ERREUR -->
        <div v-else-if="error" class="mx-6 bg-red-50 rounded-2xl p-6 text-center w-full max-w-sm">
            <p class="text-red-500 font-bold mb-3">Impossible de charger</p>
            <button
                class="px-5 py-2.5 bg-red-500 text-white text-sm font-bold rounded-xl"
                @click="loadData"
            >
                Réessayer
            </button>
        </div>

        <!-- WORK MODE -->
        <WorkMode
            v-else-if="intervention"
            :intervention="intervention"
            @end="onMissionEnd"
        />

    </div>
</template>

<script>
import WorkMode from './Intervention.vue';

export default {
    name: 'InterventionStart',
    components: { WorkMode },

    data() {
        return {
            loading: true,
            error: null,
            intervention: null,
        };
    },

    computed: {
        interventionId() { return this.$route.params.id; },
    },

    created() { this.loadData(); },

    methods: {
        async loadData() {
            this.loading = true;
            this.error   = null;

            try {
                const cached = localStorage.getItem(`intervention-${this.interventionId}`);
                if (cached) this.intervention = JSON.parse(cached);
            } catch {}

            try {
                const res = await this.$request.get(
                    `/interventions/${this.interventionId}?with_travaux=1&with_chantier=1`,
                    {}
                );
                if (res) {
                    this.intervention = res;
                    try { localStorage.setItem(`intervention-${this.interventionId}`, JSON.stringify(res)); } catch {}
                }
            } catch (e) {
                if (!this.intervention) this.error = e?.message || 'Erreur réseau';
            } finally {
                this.loading = false;
            }
        },

        onMissionEnd() {
            this.clearCache();
            this.$router.replace(`/chantier/${this.intervention?.chantier_id}/list`);
        },

        clearCache() {
            const id = this.interventionId;
            [
                `intervention-${id}`,
                `travaux-${id}`,
                `intervention-form-${id}`,
                `intervention:${id}:pv_reception`,
                `intervention:${id}:attestation_entretien`,
                `intervention:${id}:contrat_entretien`,
                `cerfa_draft_${id}`,
            ].forEach(k => { try { localStorage.removeItem(k); } catch {} });
        },
    },
};
</script>